import {Field, FieldArray} from 'formik';
import {Group, Text} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {FlexiAddButton, FlexiDeleteButton, FormikSelect, FormikTextInput} from '@flexinet/ui-components';

import {FieldError} from './FieldError';
import {TERM_LABELS} from '../config/labels';
import {CURRENCY, DimensionFormValues, PRICE_TERMS} from '../types';

const termOptions = () => PRICE_TERMS.map(term => ({value: term, label: I18n.get(TERM_LABELS[term])}));

// One row per term. Currency is fixed: it is shown, sent as USD, never chosen.
export const PriceRows = ({index, dimension}: { index: number, dimension: DimensionFormValues }) => (
    <FieldArray name={`dimensions.${index}.prices`}>
        {({push, remove}) => (
            <>
                {dimension.prices.map((_price, priceIndex) => (
                    <Group key={priceIndex} align='flex-start' wrap='nowrap'>
                        <Field
                            name={`dimensions.${index}.prices.${priceIndex}.term`}
                            label={I18n.get('Term')}
                            component={FormikSelect}
                            data={termOptions()}
                            allowDeselect={false}
                            withAsterisk
                        />
                        <Field
                            name={`dimensions.${index}.prices.${priceIndex}.amount`}
                            label={I18n.get('Amount')}
                            placeholder='49.00'
                            component={FormikTextInput}
                            withAsterisk
                        />
                        <Text pt='lg' aria-label={I18n.get('Currency')}>{CURRENCY}</Text>
                        <FlexiDeleteButton
                            mt='lg'
                            size='xs'
                            aria-label={`${I18n.get('Remove price')} ${priceIndex + 1}`}
                            onClick={(e) => {
                                e.preventDefault();
                                remove(priceIndex);
                            }}
                        >
                            {I18n.get('Remove')}
                        </FlexiDeleteButton>
                    </Group>
                ))}
                <FieldError name={`dimensions.${index}.prices`}/>
                <Group>
                    <FlexiAddButton
                        size='xs'
                        aria-label={`${I18n.get('Add price to')} ${dimension.name || I18n.get('unit')}`}
                        onClick={(e) => {
                            e.preventDefault();
                            push({term: '', amount: '', currency: CURRENCY});
                        }}
                    >
                        {I18n.get('Add price')}
                    </FlexiAddButton>
                </Group>
            </>
        )}
    </FieldArray>
);
